import getScrollbarWidth from '../helpers/get-scrollbar-width'
export default () => {
	const searchSection = document.querySelector('.search-section');
	const openSearch = document.querySelectorAll('.header-account__search');
	const closeSearch = document.querySelector('.search-section__close');

	if (searchSection) {
		openSearch.forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				searchSection.classList.add('active')
				document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = getScrollbarWidth() + 'px';
			});
		});

		closeSearch.addEventListener('click', (e) => {
			e.preventDefault();
			searchSection.classList.remove('active');
			document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0';
		});
	}
};
